'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes$SUBSCRIB;

var _underscore = require('underscore');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ClientActions = require('conversations-core/actions/ClientActions');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_ActionTypes$SUBSCRIB = {}, _defineProperty(_ActionTypes$SUBSCRIB, _ActionTypes2.default.SUBSCRIBE_CONFIRMATION, function (action, getState, dispatch) {
  var isInitialSubscribe = !(0, _clientSelectors.getSubscribeConfirmationTimestamp)(getState());
  if (isInitialSubscribe) {
    (0, _underscore.defer)(function () {
      return dispatch((0, _ClientActions.getServerTimeOffset)());
    });
  }
}), _defineProperty(_ActionTypes$SUBSCRIB, _ActionTypes2.default.GET_SERVER_TIME_OFFSET_SUCCEEDED, function (action, getState, dispatch) {
  (0, _underscore.defer)(function () {
    return dispatch((0, _ClientActions.conversationsClientReady)());
  });
}), _ActionTypes$SUBSCRIB);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubHandlers/networkHandlers.js
// module id = 497
// module chunks = 0